import React, { useState, useEffect } from "react";
import { Modal, Row, Col, Card, Button, Spinner, Table } from "react-bootstrap";
import { TextField, Box, Typography } from "@mui/material";
import SaveIcon from "@mui/icons-material/SaveRounded";
import CloseIcon from "@mui/icons-material/CloseRounded";
import SwalMessage from "../../_Components/SwalMessage";
import { Link } from "react-router-dom";
import { useForm, Controller, useController } from "react-hook-form";
import Select from "react-select";
import ApiSupplierService from "../../../../core/api/api.supplier";
import _ from "lodash";
// import { DropzoneArea } from "material-ui-dropzone";
import ApiSupplier from "../../../../core/api/api.supplier";
import Dropzone from "react-dropzone";

/* import { GridList, GridListTile } from "@mui/material";
import ImageViewer from 'react-simple-image-viewer';
import Jimp from "jimp";
import { LazyLoadImage } from 'react-lazy-load-image-component'; */

const Index = (props) => {
  const [allRegionList, setallRegionList] = useState([]);
  const [licenseType, setlicenseType] = useState([]);
  const [files, setFiles] = useState([]);
  const [imageSrc, setImageSrc] = useState([]);
  const [fileGet, setFileGet] = useState([]);
  const [showImage, setshowImage] = useState("");
  const [historySupplierData, setHistorySupplierData] = useState([]);

  let handleClose = (e) => {
    // !_.isEmpty(e) && e.stopPropagation();
    // history.goBack();
    setshowImage("");
  };
  const {
    register: register,
    handleSubmit: handleSubmit,
    control: control,
    formState: { errors: errors, isSubmitting },
    reset: reset,
    getValues: getValues,
    setValue: setValue,
    watch,
  } = useForm({ defaultValues: { supplierId: 0 } });

  useEffect(() => {
    (async () => {
      try {
        let checkSupplierProfile = ApiSupplier.getSupplierById("").then(
          (rest) => {
            if (rest?.data?.supplierId != 0) {
              setImageSrc(rest?.data?.files);
              setValue("supplierId", rest.data.supplierId);
              setValue("address", rest.data.address);
              setValue("cEOFirstName", rest.data.ceoFirstName);
              setValue("cEOIdentityNumber", rest.data.ceoIdentityNumber);
              setValue("cEOLastName", rest.data.ceoLastName);
              setValue("companyName", rest.data.companyName);
              setValue("companyNationalId", rest.data.companyNationalId);
              setValue("city", [
                { value: rest.data.city.id, label: rest.data.city.name },
              ]);
              setValue("ceoIdentityNumber", rest.data.ceoIdentityNumber);
              setValue("cEOMobile", rest.data.ceoMobile);
              setValue("phone", rest.data.phone);
              setValue("supportMobile", rest.data.supportMobile);
              setValue("approvalStatus", rest.data.supplierApprovalStatusS);
              setHistorySupplierData(rest.data.statusJsonArray);
              setValue("licenseType", [
                { value: rest.data.licenseType, label: rest.data.licenseTypeS },
              ]);
              let uniqueFiles = new Set();
              if (!_.isEmpty(rest?.data?.files)) {
                let pp = rest?.data?.files.map((item) => {
                  let obj = { fileId: item };

                  ApiSupplierService.getFile(obj)
                    .then((response) => {
                      let objectURL = URL.createObjectURL(new Blob([response]));
                      // بررسی اینکه آیا این URL قبلاً وجود دارد یا نه
                      if (!uniqueFiles.has(objectURL)) {
                        uniqueFiles.add(objectURL);
                        setFileGet((oldFileGet) => {
                          // فقط افزودن اگر تکراری نباشد
                          if (!oldFileGet.includes(objectURL)) {
                            return [...oldFileGet, objectURL];
                          }
                          return oldFileGet;
                        });
                      }
                    })
                    .catch(console.log);
                });
              }
            }
          }
        );

        const apiData = await ApiSupplierService.getAllRegion();
        if (!_.isEmpty(apiData)) {
          setallRegionList(apiData.data);
        } else {
          setallRegionList([]);
        }

        const response2 = await ApiSupplierService.getLicenseTypeStatus({
          enumType: "AgentLicenseType",
        });

        if (!_.isEmpty(response2.data)) {
          setlicenseType(response2.data);
        } else {
          setlicenseType([]);
        }
      } catch (error) {
        console.log("error :>> ", error);
      } finally {
      }
    })();
    return () => {};
  }, []);

  const onSubmit = async (data) => {
    try {
      let flag = 0;
      if (!_.isEmpty(data)) {
        if (!_.isEmpty(data.city)) {
          data.cityId = !_.isUndefined(data.city.value)
            ? data.city.value
            : data.city[0].value;
        } else {
          SwalMessage({
            title: "لطفا شهر آژانس را انتخاب نمایید",
            iSsuccess: false,
          });
          flag = 1;
          return;
        }
        if (
          data?.licenseType != [] &&
          !_.isEmpty(data?.licenseType) &&
          !_.isUndefined(data?.licenseType)
        ) {
          data.licenseType = !_.isUndefined(data?.licenseType?.value)
            ? data.licenseType.value
            : data.licenseType[0].value;
        } else {
          SwalMessage({
            title: "لطفا مجوز آژانس را انتخاب نمایید",
            iSsuccess: false,
          });
          flag = 1;
          return;
        }
      }

      if (flag == 0) {
        try {
          const formData = new FormData();
          for (const [key, value] of Object.entries(data)) {
            if (key !== "attachments") {
              !_.isUndefined(value) && formData.append(key, value);
            }
          }

          // تبدیل کردن FileList به آرایه
          const attachmentsArray = Array.from(data?.attachments || []);

          // استفاده از forEach برای اضافه کردن فایل‌ها
          attachmentsArray.forEach((element) => {
            formData.append("attachments", element);
          });

          const response3 =
            await ApiSupplierService.createandEditSupplierCommand(formData);
          SwalMessage({
            title: response3.message,
            iSsuccess: response3.succeeded,
          });
          response3.succeeded && setValue("supplierId", response3.data);
        } catch (error) {
          console.log("error=", error);
        }
      }
    } catch (error) {
      console.error("Save error:", error);
    }
  };

  function handleChangeMulti(event) {
    setValue("city", event);
  }
  function handleChangeLicense(event) {
    setValue("licenseType", event);
  }
  const selectStyles = {
    menu: (base) => ({
      ...base,
      zIndex: 10000,
    }),
  };

  // تابع برای حذف فایل
  const handleRemoveFile = (fileToRemove) => {
    const updatedFiles = files.filter((file) => file !== fileToRemove);
    setFiles(updatedFiles);
    alert(`${fileToRemove.name} از لیست ارسالی حذف گردید.`);
  };

  // تابع برای مشاهده فایل‌ها
  const viewImageFile = (fileUrl) => () => {
    window.open(fileUrl, "_blank");
  };

  return (
    <div>
      <Modal
        centered
        size="lg"
        show={showImage != "" ? true : false}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          {/* <Modal.Title>ایجاد گروه تخفیف </Modal.Title> */}
        </Modal.Header>
        <Modal.Body></Modal.Body>
        <img src={showImage} width="80%" height="80%" alt="" />

        <Modal.Footer>
          <Button variant="danger" onClick={handleClose}>
            <CloseIcon /> بستن
          </Button>
        </Modal.Footer>
      </Modal>
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pb-3 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              تامین کننده محترم به پلتفرم تفریحان خوش آمدید
            </span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">
              لطفا اطلاعات خواسته شده فرم زیر را تکمیل کنید و در نهایت ذخیره
              نمایید.
            </span>
          </h3>
        </div>
        {/*Start body */}
        <form key={2} id="form2" onSubmit={handleSubmit(onSubmit)}>
          <div className="card-body pt-3 pb-0 border-top">
            <Row>
              <Col xs="12" sm="7" lg="12">
                <Row>
                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="approvalStatus"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="اخرین وضعیت شما"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value?.replace("_", " ") || "جدید"}
                          disabled
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="companyName"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="نام شرکت"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                  </Col>

                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="companyNationalId"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="شناسه ملی شرکت"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="cEOIdentityNumber"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="شماره ملی مدیرعامل"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                          inputProps={{ maxLength: 10 }}
                        />
                      )}
                    />
                  </Col>

                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="city"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          placeholder="انتخاب شهر آژانس(جهت جستجولطفا تایپ کنید)"
                          styles={selectStyles}
                          className="mt-5"
                          inputId="react-select-multiple"
                          TextFieldProps={{
                            label: "Countries",
                            InputLabelProps: {
                              htmlFor: "react-select-multiple",
                              shrink: true,
                            },
                            placeholder: "Select multiple countries",
                          }}
                          options={allRegionList?.map((item) => ({
                            value: item.id,
                            label: item.name,
                          }))}
                          value={value || ""}
                          onChange={handleChangeMulti}
                          label="انتخاب شهر شرکت"
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="licenseType"
                      control={control}
                      render={({ field: { onChange, value } }) => (
                        <Select
                          placeholder="مجوز شرکت"
                          styles={selectStyles}
                          className="pb-3 mt-5"
                          inputId="react-select-multiple"
                          TextFieldProps={{
                            label: "Countries",
                            InputLabelProps: {
                              htmlFor: "react-select-multiple",
                              shrink: true,
                            },
                            placeholder: "Select multiple countries",
                          }}
                          options={licenseType?.map((item) => ({
                            value: item.value,
                            label: item.title,
                          }))}
                          value={value || ""}
                          onChange={handleChangeLicense}
                          label="انتخاب مجوز شرکت"
                        />
                      )}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="cEOFirstName"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="نام مدیر عامل"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                  </Col>
                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="cEOLastName"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="نام خانوادگی عامل"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                  </Col>

                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="cEOMobile"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="موبایل مدیرعامل"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                  </Col>

                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="phone"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="تلفن شرکت"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                  </Col>

                  <Col xs="12" sm="7" lg="6" xl="4">
                    <Controller
                      name="supportMobile"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="موبایل پشتیبانی"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                  </Col>

                  <Col xs="12" sm="7" lg="12" xl="4">
                    <Controller
                      name="address"
                      control={control}
                      rules={{}}
                      render={({ field: { onChange, value } }) => (
                        <TextField
                          label="آدرس شرکت"
                          margin="normal"
                          variant="outlined"
                          size="small"
                          value={value || ""}
                          onChange={onChange}
                        />
                      )}
                    />
                  </Col>
                </Row>
              </Col>
              <hr />
              <Row className="mt-5">
                <Col xs="12" sm="7" lg="12" className="mt-3 mt-lg-0">
                  <Controller
                    name="attachments"
                    control={control}
                    render={({ field }) => (
                      <Dropzone
                        onDrop={(acceptedFiles, rejectedFiles) => {
                          // ابتدا بررسی تعداد فایل‌ها
                          if (
                            acceptedFiles.length + files.length > 3 ||
                            rejectedFiles.length > 3
                          ) {
                            SwalMessage({
                              title:
                                "امکان ارسال بیشتر 3 فایل در هر آپلود وجود ندارد.",
                              iSsuccess: false,
                            });
                            return;
                          }

                          // سپس بررسی فایل‌های رد شده
                          if (rejectedFiles.length > 0) {
                            SwalMessage({
                              title:
                                "فقط فایل‌های عکس را می‌توانید آپلود نمایید.",
                              iSsuccess: false,
                            });
                            return;
                          }

                          const newFiles = acceptedFiles.map((file) =>
                            Object.assign(file, {
                              preview: URL.createObjectURL(file),
                            })
                          );

                          setFiles((prevFiles) => [...prevFiles, ...newFiles]);
                          field.onChange([...files, ...newFiles]);
                        }}
                        useFsAccessApi={false}
                        accept={{
                          "image/jpeg": [],
                          "image/png": [],
                          "image/jpg": [],
                        }}
                        maxFiles={3}
                        multiple={true}
                      >
                        {({ getRootProps, getInputProps }) => (
                          <Box
                            {...getRootProps()}
                            sx={{
                              border: "2px dashed gray",
                              p: 2,
                              textAlign: "center",
                            }}
                          >
                            <input {...getInputProps()} />
                            <Typography>انتخاب فایل</Typography>
                          </Box>
                        )}
                      </Dropzone>
                    )}
                  />

                  <div className="file-preview">
                    {files.map((file, index) => (
                      <div key={index} className="file-item">
                        <img src={file.preview} alt="Preview" width="50" />
                        <span>{file.name}</span>
                        <button
                          type="button"
                          onClick={() => handleRemoveFile(file)}
                        >
                          حذف
                        </button>
                      </div>
                    ))}
                  </div>
                </Col>
                <Col xs="12" sm="7" lg="12">
                  <h6 className="my-5">تصاویر مدارک ارسال شده:</h6>

                  {/* <div>fileGet {fileGet?.length}</div> && */}
                  {fileGet?.length > 0 ? (
                    <div
                      className="d-flex  mt-1 "
                      style={{ overflowX: "scroll" }}
                    >
                      {fileGet.map((item) => (
                        <img
                          key={item}
                          src={item}
                          width="20%"
                          alt=""
                          height="20%"
                          style={{ cursor: "pointer" }}
                          onClick={viewImageFile(item)}
                        />
                      ))}
                    </div>
                  ) : (
                    <p>تصویر مدارک پیدا نشد .</p>
                  )}
                </Col>
              </Row>
              <Row className="mt-5 w-100">
                <Col xs="12" sm="7" lg="12">
                  <h6 className="my-5">آخرین وضعیت پروفایل شما:</h6>
                  <Table striped responsive hover>
                    <thead>
                      <tr>
                        <th>#</th>
                        <th>وضعیت</th>
                        <th>توضیحات</th>
                        <th>توسط</th>
                        <th>تاریخ</th>
                      </tr>
                    </thead>
                    <tbody>
                      {historySupplierData?.map((item, index) => (
                        <tr>
                          <td>{index}</td>
                          <td>{item.supplierApprovalStatusS}</td>
                          <td>{item.discription}</td>
                          <td>{item.createdByS}</td>
                          <td>{item.createdS}</td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </Col>
              </Row>
            </Row>
          </div>
          <div className="card-footer ">
            <Button variant="success" type="submit" disabled={isSubmitting}>
              {isSubmitting && (
                <Spinner animation="border" variant="warning" size="sm" />
              )}
              <SaveIcon /> ذخیره
            </Button>
            <Link className="btn btn-danger ml-3" to="/dashboard">
              <CloseIcon /> بازگشت
            </Link>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Index;
